import { WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { isInSyncing } from '@futrli/shared-services/organisations/utils/datasources-status-utils';

/**
 * Returns a list of datasource IDs that are in syncing state from the provided workspaces.
 * @param workspaces - The list of workspaces to check for datasources in syncing state
 */
export const workspaceOrgDatasourcesInSyncing = (workspaces?: WorkspacesListingItem[]) => {
  if (!workspaces) {
    return [];
  }
  const orgs = workspaces.flatMap(w => w.organisations.filter(o => !!o.datasource && isInSyncing(o.datasource)));
  return Array.from(new Set(orgs.flatMap(org => (org.datasource?.id ? [org.datasource.id] : [])))).sort();
};
